import React from "react";
import { Field, reduxForm } from "redux-form";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ToastContainer, toast } from "react-toastify";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import { Typography } from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";
import { RemoveShoppingCartSharp } from "@material-ui/icons";
import { ADMIN_MSGS } from "../../../Constant/Messages";
const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    margin="normal"
    fullWidth
    label={label}
    error={touched && error}
    helperText={error}
    {...input}
    {...custom}
    InputLabelProps={{
      style: {
        color: "black",
        fontFamily: "GT-Walsheim-medium",
        fontSize: "14px",
      },
    }}
  />
);

const renderDropDown = ({input,label,props,meta: { touched, error },...custom}) => (
  <FormControl style={{ width: "100%", marginTop: "25px" }}>
    <InputLabel
      id="demo-simple-select-autowidth-label"
      style={{
        fontFamily: "GT-Walsheim-medium",
        fontSize: "14px",
        color: "black",
      }}
    >
      {label || "Role *"}
    </InputLabel>
    <Select
      labelId="demo-simple-select-helper-label"
      id="demo-simple-select-error"
      // value={age}
      label={label}
      autoFocus
      error={touched && error}
      helperText={error}
      {...input}
      {...custom}
      InputLabelProps={{
        style: {
          color: "black",
          fontFamily: "GT-Walsheim-medium",
          fontSize: "14px",
        },
      }}
    >
      {custom.names.map((name, index) => (
        <MenuItem key={index} value={name.id}>
          {name.name}
        </MenuItem>
      ))}
    </Select>
    <FormHelperText style={{ color: "red" }}>{error}</FormHelperText>
  </FormControl>
);

const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d@$.!%*#?&]/;
const testEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

const numberRegex = /^[0-9]+$/;
const alphabetRegex = /^[A-Za-z]+$/;

const validate = (values) => {
  const errors = {};
  const requiredFields = [
    "partnerName",
    "partnerEmail",
    "department",
    "region"
  ];
  requiredFields.forEach((field) => {
    if (field == "partnerEmail" && !testEmail.test(values[field])) {
      errors[field] = "Enter Valid Email";
    }
    if (!values[field] || values[field] == "") {
      errors[field] = "Required";
    }
  });

  if (values.password && values.password.length < 8) {
    errors.password = ADMIN_MSGS.PASSWORD_MIN_LENGTH;
  } else if (values.password && values.password.length > 20) {
    errors.password = ADMIN_MSGS.PASSWORD_MAX_LENGTH;
  } else if (values.password && !regex.test(values.password)) {
    errors.password = ADMIN_MSGS.PASSWORD_SPECIAL_CHAR;
  }

  if (numberRegex.test(values.entityName)) {
    errors.entityName = ADMIN_MSGS.COMPANY_NAME_ALPHANUMERIC;
  }
  if (values.panNo?.length != 10) {
    errors.panNo = ADMIN_MSGS.PAN_INVALID;
  }
  if (numberRegex.test(values.panNo) || alphabetRegex.test(values.panNo)) {
    errors.panNo = ADMIN_MSGS.PAN_INVALID;
  }
  if (!alphabetRegex.test(values.repName)) {
    errors.repName = ADMIN_MSGS.REP_NAME_INVALID;
  }
  return errors;
};

class EditCompanyProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      partnerName:"",
      partnerEmail:"",
      department:"",
      region:""
    };
  }

  componentDidMount() {
    console.log("firstName", this.props.EditUser);

    this.props.initialize({
      partnerName:this.props.EditUser.name,
      partnerEmail:this.props.EditUser.email,
      department:this.props.EditUser.departmentID,
      region:this.props.EditUser.regionID,
      id: this.props.EditUser.id
    });
  }

  render() {
    console.log("NewData==@@", this.state.isAuditClient);
    const { handleSubmit } = this.props;
    return (
      <div style={{ width: "100%" }} id="CreateUser">
        <form
          style={{ width: "100%", paddingBottom: "5%" }}
          onSubmit={handleSubmit(this.props.onSubmit)}
        >
          <div class="row">
            <div class="col-md-6">
              <Field
                name="partnerName"
                component={renderTextField}
                label="Partner Name *"
                style={{ paddingTop: "6%" }}
              />
            </div>
            <div class="col-md-6">
              <Field
                name="partnerEmail"
                component={renderTextField}
                label="Partner Email *"
                style={{ paddingTop: "6%" }}
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <Field
                name="department"
                component={renderDropDown}
                label="Department Name *"
                style={{ paddingTop: "6%" }}
                names={this.props.departmentList}
              />
            </div>
            <div class="col-md-6">
              <Field
                name="region"
                component={renderDropDown}
                label="Region Name *"
                names={this.props.regionList}
              />
            </div>
          </div>
          <div className={"d-flex justify-content-center align-items-center"}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                marginTop: "15px",
              }}
            >
              Sumbit
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: "EditCompanyProfile",
  validate,
})(EditCompanyProfile);
